export default __webpack_public_path__ + "static/icon-phone-blue-d017a489cdb24c59459d9e34b8f229e1.png";